export const DASHBOARD_URL = '/dashboard';

export const DASHBOARD_HOME_URL = DASHBOARD_URL + '/(panel:home)';
export const PANEL_OUTLET_URL = 'panel';
